/**
 * ruleApi 用于 API 验证规则参数统一封装返回
 */
import Vue from 'vue'

// 规则列表接口设置
function setRule (typeVal) {
    let list = {}
    let mobileReg = /^1\d{10}$/
    //let emailReg = /^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$/
    let passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8,15}$/;
    let thanZeroReg =  /^[1-9]\d*$/ //大于0正则表达式
    let towFloatNumReg = /^((([1-9]\d+)|\d)(\.\d\d?)?)$/ //两位小数
    // let eightFloatNumReg = /^(([1-9]\d+)|\d)(\.\d{1,8})$/   //8位小数
    let eightFloatNumReg =   /^\d{1,11}$|^\d{1,11}[.]\d{1,8}$/   //8位小数

    let percentNumReg = /^((([1-9]\d+)|\d))$/  // /^\d+\.?\d*\%$/ //验证百分数
    let towPercentNumReg = /^((([1-9]\d+)|\d)(\.\d\d?)?)$/  // /^\d+\.?\d*\%$/ //验证百分数
    switch (typeVal) {
        case 'user':
            list = {
                account:[
                    { required: true, message: '请输入账号名', trigger: 'blur' },
                ],
                name:[
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                ],
                email:[
                    { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
                ],
                mobile:[
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: mobileReg, message: '请输入正确的手机号码', trigger: 'blur' }
                ],
                password:[
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { pattern: passwordReg, message: '请输入8-15位数字大小写字母组合密码', trigger: 'blur' }
                ],
                roleId:[
                    { required: true, message: '请分配用户角色', trigger: 'change' },
                ],
                enableFlag:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ]
            }
        break
        case 'role':
            list = {
                name:[
                    { required: true, message: '请输入角色名称', trigger: 'blur' },
                ],
                enableFlag:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ]
            }
        break
        case 'menu':
            list = {
                menuName:[
                    { required: true, message: '请输入菜单名称', trigger: 'blur' },
                ],
                menuCode:[
                    { required: true, message: '请输入菜单编码', trigger: 'blur' },
                ],
                menuType:[
                    { required: true, message: '请选择菜单类型', trigger: 'change' },
                ],
                menuParentCode:[
                    { required: true, message: '请选择父菜单', trigger: 'change' },
                ],
                menuSortNum:[
                    { required: true, message: '请输入排序号', trigger: 'blur' },
                    { pattern: thanZeroReg, message: '请输入大于0的整数', trigger: 'blur' }
                ],
                enableFlag:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ]
            }
        break
        case 'button':
            list = {
                buttonCode:[
                    { required: true, message: '请选择按钮类型', trigger: 'change' },
                ],
                enableFlag:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ]
            }
        break
        case 'enum':
            list = {
                enumKey:[
                    { required: true, message: '请输入枚举编码', trigger: 'blur' },
                ],
                enumName:[
                    { required: true, message: '请输入枚举名称', trigger: 'blur' },
                ],
                enumKeyValue:[
                    { required: true, message: '请输入枚举编码值', trigger: 'blur' },
                ],
                // menuParentCode:[
                //     { required: true, message: '请选择父枚举', trigger: 'change' },
                // ],
                enumSortNumber:[
                    { required: true, message: '请输入排序号', trigger: 'blur' },
                    { pattern: thanZeroReg, message: '请输入大于0的整数', trigger: 'blur' }
                ],
                enableFlag:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ]
            }
        break
        case 'dataDic'://数据字典
            list = {
                // dicCode:[
                //     { required: true, message: '输入字典编码', trigger: 'blur' },
                // ],
                dicName:[
                    { required: true, message: '请输入字典名称', trigger: 'blur' },
                ]
            }
        break
        //配置界面

        case 'valueSet':
            list = {
                valuesetName:[
                    { required: true, message: '请输入值集名称', trigger: 'blur' },
                ],
                valuesetCode:[
                    { required: true, message: '请输入值集编码', trigger: 'blur' },
                ],
                enableFlag:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ],
                fixedFlag:[
                    { required: true, message: '请选择是否可修改', trigger: 'change' },
                ]
            }
        break
        case 'valueSetLine':
            list = {
                valuesetLineContent:[
                    { required: true, message: '请输入值集行名称', trigger: 'blur' },
                ],
                valuesetLineCode:[
                    { required: true, message: '请输入值集行编码', trigger: 'blur' },
                ],
                enableFlag:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ]
            }
        break
        case 'year'://财年
            list = {
                fiscalYear:[
                    { required: true, message: '请输入财年', trigger: 'blur' },
                ],
                startDate:[
                    { required: true, message: '请输入开始日期', trigger: 'blur' },
                ],
                periodStatus:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ]
            }
        break
        case 'data'://数据权限
            list = {
                accountId:[
                    { required: true, message: '请选择OA账号', trigger: 'blur' },
                ],
                primaryLedger:[
                    { required: true, message: '请选择主账套', trigger: 'blur' },
                ],
                secondaryLedger:[
                    { required: true, message: '请选择辅账套', trigger: 'change' },
                ]
            }
        break
        case 'taxRate'://税率
            list = {
                taxName:[
                    { required: true, message: '请输入税码', trigger: 'blur' },
                ],
                taxType:[
                    { required: true, message: '请选择税种', trigger: 'blur' },
                ],
                region:[
                    { required: true, message: '请输入国家和地区', trigger: 'blur' },
                ],
                deductible:[
                    { required: true, message: '请选择是否抵扣', trigger: 'blur' },
                ],
                taxLogic:[
                    { required: true, message: '请选择计税逻辑', trigger: 'blur' },
                ],
                taxRate:[
                    { required: true, message: '请输入税率', trigger: 'blur' },
                    { pattern: towFloatNumReg, message: '请输入两位小数', trigger: 'blur' }
                ],
            }
        break
        case 'exchangeRate'://汇率
            list = {
                operatingUnit:[
                    { required: true, message: '请输入业务实体', trigger: 'blur' },
                ],
                currencyFrom:[
                    { required: true, message: '请输入币种从', trigger: 'blur' },
                ],
                currencyTo:[
                    { required: true, message: '请输入币种至', trigger: 'blur' },
                ],
                startDate:[
                    { required: true, message: '请输入开始日期', trigger: 'blur' },
                ],
                endDate:[
                    { required: true, message: '请输入结束日期', trigger: 'blur' },
                ],
                exchangeRate:[
                    { required: true, message: '请输入汇率', trigger: 'blur' },
                    // { pattern: towFloatNumReg, message: '请输入两位小数以内的数值', trigger: 'blur' }
                    { pattern: eightFloatNumReg, message: '请输入最多8位小数', trigger: 'blur' }
                ],
                enableFlag:[
                    { required: true, message: '请选择状态', trigger: 'change' },
                ],
            }
        break
        case 'primaryData'://租赁主数据
            list = {
                primaryLedger:[
                    { required: true, message: '请输入主账套', trigger: 'blur' },
                ],
                secondaryLedger:[
                    // { required: true, message: '请输入辅账套', trigger: 'blur' },
                ],
                operatingUnit:[
                    { required: true, message: '请输入业务实体', trigger: 'blur' },
                ],
                legalEntity:[
                    { required: true, message: '请输入法务实体', trigger: 'blur' },
                ],
                region:[
                    { required: true, message: '请输入国家和地区', trigger: 'blur' },
                ],
                functionalCurrency:[
                    { required: true, message: '请输入币种', trigger: 'blur' },
                ]
            }
        break
        case 'loanInterest'://租赁主数据
            list = {
                operatingUnit:[
                    { required: true, message: '请输入业务实体', trigger: 'blur' },
                ],
                discountRateType:[
                    { required: true, message: '请输入利率类型', trigger: 'blur' },
                ],
                contractCurrency:[
                    { required: true, message: '请输入合同币种', trigger: 'blur' },
                ],
                region:[
                    { required: true, message: '请输入地区', trigger: 'blur' },
                ],
                leaseItemType:[
                    { required: true, message: '请输入租赁物件类型', trigger: 'blur' },
                ],
                leaseTermFrom:[
                    { required: true, message: '请输入租赁周期起', trigger: 'blur' },
                    { pattern: thanZeroReg, message: '请输入大于0的整数', trigger: 'blur' }
                ],
                leaseTermTo:[
                    { required: true, message: '请输入租赁周期止', trigger: 'blur' },
                    { pattern: thanZeroReg, message: '请输入大于0的整数', trigger: 'blur' }
                ],
                discountRateEffectiveFrom:[
                    { required: true, message: '请输入利率生效日期', trigger: 'blur' },
                ],
                discountRateEffectiveTo:[
                    { required: true, message: '请输入利率终止日期', trigger: 'blur' },
                ],
                // leaseContractAmountFrom:[
                //    // { required: true, message: '请输入租赁合同金额范围起', trigger: 'blur' },
                //     { pattern: towFloatNumReg, message: '请输入两位小数以内的数值', trigger: 'blur' }
                // ],
                // leaseContractAmountTo:[
                //     //{ required: true, message: '请输入租赁合同金额范围止', trigger: 'blur' },
                //     { pattern: towFloatNumReg, message: '请输入两位小数以内的数值', trigger: 'blur' }
                // ],
                discountRateSource:[
                    { required: true, message: '请输入折现率来源', trigger: 'blur' },
                ],
                discountRate:[
                    { required: true, message: '请输入年折现率', trigger: 'blur' },
                    { pattern: towPercentNumReg, message: '请输入两位小数以内的百分数', trigger: 'blur' }
                ]
            }
        break
        case 'accountRule'://科目规则
            list = {
                contentName:[
                    { required: true, message: '请输入分录行场景', trigger: 'change' },
                ],
                dcDirection:[
                    { required: true, message: '请输入方向', trigger: 'change' },
                ],
            }
        break
        case 'systemMapping'://外围系统映射
            list = {
                outsideMapCode:[
                    { required: true, message: '请输入映射名称', trigger: 'blur' },
                ],
                enableFlag:[
                    { required: true, message: '请输入状态', trigger: 'blur' },
                ]
            }
        break
        case 'systemMappingLine'://外围系统映射行
            list = {
                leaseTermInput:[
                    { pattern: thanZeroReg, message: '请输入大于0的整数', trigger: 'blur' }
                ],
                usefulLifeInput:[
                    { pattern: thanZeroReg, message: '请输入大于0的整数', trigger: 'blur' }
                ]
            }
        break

        //操作界面
        case 'accountPeriodRule'://过账选择会计期
            list = {
                periodName:[
                   { required: true, message: '请选择会计期', trigger: 'change' },
                ]
            }
        break
        default:
        break
    }
    return list
}

// 获取规则并返回前端
const ruleApi = {
    ruleObj: {},
    getRule (type) {
        this.ruleObj = setRule(type)
        return this.ruleObj
    }
}

export default ruleApi



// WEBPACK FOOTER //
// ./src/api/rules/rule.js